import React, { type PropsWithChildren } from "react";
import MuiDialogContent, {
  type DialogContentProps as MuiDialogContentProps,
} from "@mui/material/DialogContent";

export interface MelaDialogContentProps extends MuiDialogContentProps {}

export const MelaDialogContent = ({
  children,
  dividers = true,
  ...dialogContentProps
}: PropsWithChildren<MelaDialogContentProps>) => (
  <MuiDialogContent dividers={dividers} {...dialogContentProps}>
    {children}
  </MuiDialogContent>
);
